<template>
  <div>
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      جدید +
    </button>

    <div class="text-center mt-5" v-if="get_data_loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <div v-else>
      <div class="mt-3" v-for="router in routers" :key="router">
        <div class="shadow p-3 mb-3 bg-body rounded d-flex align-items-center">{{ router.address }}
          <router-link class="btn btn-primary me-auto" :to="'/admin/routers/router/' + router._id">مدیریت</router-link>
        </div>
      </div>
    </div>


    <div class="modal fade" id="exampleModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" ref="modal"></button>
            <h5 class="modal-title" id="exampleModalLabel">آی پی جدید</h5>
          </div>
          <div class="modal-body">

            <div class="row" dir="ltr">
              <div class="col-md-12 mt-2">
                <input type="text" class="form-control" placeholder="آدرس روتر" v-model="data.address">
              </div>
              <div class="col-md-6 mt-2">
                <input type="text" class="form-control" placeholder="username" v-model="data.username">
              </div>
              <div class="col-md-6 mt-2">
                <input type="text" class="form-control" placeholder="password" v-model="data.password">
              </div>

              <div class="form-check ms-3 mt-2">
                <input class="form-check-input" type="checkbox" value="" id="flexCheck" checked v-model="data.ssl">
                <label class="form-check-label" for="flexCheck">
                  SSL
                </label>
              </div>

            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="send()" :disabled="loading">
              ذخیره
              <span class="spinner-border spinner-border-sm" v-show="loading"></span>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ref } from '@vue/reactivity';
import { inject } from '@vue/runtime-core';
import axios from 'axios';
import { onMounted } from '@vue/runtime-core';
export default {
  setup() {
    const loading = ref(false);
    const get_data_loading = ref(true);
    const toast = inject("toast");
    const modal = ref();
    const routers = ref([]);
    const data = ref({
      address: '',
      username: '',
      password: '',
      ssl: true
    })

    function send() {
      loading.value = true;
      axios.post('/admin/new-router', data.value)
        .then(function (response) {
          getData()
          loading.value = false;
          toast.success("افزودن روتر با موفقیت انجام شد");
          modal.value.click();
          console.log(response.data);
        })
        .catch(function (error) {
          toast.error("افزودن روتر با خطا مواجه شد");
          loading.value = false;
          modal.value.click();
          console.log(error);
        })
    }
    function getData() {
      axios.post('/admin/get-routers', {})
        .then(function (response) {
          routers.value = response.data
          get_data_loading.value = false;
        })
        .catch(function (error) {
          console.log(error);
          get_data_loading.value = false;
        })
    }
    onMounted(() => {
      getData()
    })

    return { get_data_loading, loading, modal, routers, data, send }
  }
}
</script>

<style>

</style>